import { DateFormatter } from 'src/utils/dateformat';
import React from 'react';

interface DateTimeTplProps {
  value: Date;
}

const DateTimeTpl: React.SFC<DateTimeTplProps> = ({ value }) => <div>{DateFormatter(value)}</div>;

export default DateTimeTpl;
